import { baseClasses } from '@weatherbug/common';
import { NationalOutlookProvider } from '../providers/nationalOutlookProvider';

const { AsyncAction } = baseClasses;
export const GET_NATIONAL_OUTLOOK_BY_ID = new AsyncAction('GET_NATIONAL_OUTLOOK_BY_ID');

export function getNationalOutlookById(outlookVideoId, type) {
    return {
        type: GET_NATIONAL_OUTLOOK_BY_ID.base,
        payload: getNationalOutlook(outlookVideoId, type)
    };
}

async function getNationalOutlook(outlookVideoId, type) {
        const op = new NationalOutlookProvider();
        return await op.getNationalOutlook(outlookVideoId, type);
}
